import { render, staticRenderFns } from "./ContentLibraryCreate.vue?vue&type=template&id=52238e9f&scoped=true&"
import script from "./ContentLibraryCreate.vue?vue&type=script&lang=js&"
export * from "./ContentLibraryCreate.vue?vue&type=script&lang=js&"
import style0 from "./ContentLibraryCreate.vue?vue&type=style&index=0&id=52238e9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52238e9f",
  null
  
)

export default component.exports